import React, { useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormCampanhaMudas = ({ isEditing, isLoading, setCampanhaMudas, listMudas, setListMudas}) => {

    const { id } = useParams();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const schema = Yup.object().shape({
        mudaId: Yup
            .number()
            .required("A muda é obrigatório")
            .integer("A muda deve estar na lista"),
        quantidade: Yup
            .number()
            .required("A quantidade é obrigatório")
            .max(9999999999, "A quantidade dete ter no máximo 10 caracteres"),
    })

    useEffect(() => {

        if (isEditing) {
            api.get(`mudas/${id}`).then((response) => { formik.setValues(response.data); });
        }

    }, []);

    const formik = useFormik({

        initialValues: {
            "mudaId": 0,
            "muda": "",
            "quantidade": 0,
        },

        validationSchema: schema,

        enableReinitialize: false,

        onSubmit: async (data) => {
            let tempData = await api.get(`mudas/${data.mudaId}`);
            data.muda = tempData.data;
            data.saldo = data.quantidade;
            setIsSubmiting(true)

            setCampanhaMudas(campanhaMudas => [...campanhaMudas, data]);
            setListMudas(listMudas.filter(muda => muda.id !== data.mudaId));
            formik.setFieldValue("mudaId", 0);
            setIsSubmiting(false)
        }
    })

    const handleSubmit = () => {
        setIsSubmiting(true)
        let quantidade
        let muda
        let campanhaMuda
        if (listMudas != "")
        {
            if (listMudas.length == 1)
            {
                listMudas.map(mudas => {
                    campanhaMuda = [
                        muda = {
                            "id": mudas.id,
                            "nome": mudas.nome
                        },
                        quantidade = formik.values.quantidade
                    ]
                })
                campanhaMuda.muda = muda;
                campanhaMuda.quantidade = quantidade;    
                
                campanhaMuda = {muda: campanhaMuda[0], quantidade: campanhaMuda[1], saldo: campanhaMuda[1]}
               
                setCampanhaMudas(campanhaMudas => [...campanhaMudas, campanhaMuda]);
                listMudas.length = listMudas.length -1;
            }
            else
            {
                listMudas.map(mudas => {
                    campanhaMuda = [
                        muda = {
                            "id": mudas.id,
                            "nome": mudas.nome
                        },
                        quantidade = formik.values.quantidade
                    ]
                })
                campanhaMuda.muda = muda;
                campanhaMuda.quantidade = quantidade;                
                
                campanhaMuda = {muda: campanhaMuda[0], quantidade: campanhaMuda[1], saldo: campanhaMuda[1]}

                setCampanhaMudas(campanhaMudas => [...campanhaMudas, campanhaMuda]);
                listMudas.length = listMudas.length -1;
                handleSubmit();
            }
        }

        setIsSubmiting(false)
    }

    return (

        <Fieldset legend="Mudas" toggleable  >
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">

                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                            <div className="p-field p-col-12 p-sm-2">
                                <label
                                    htmlFor="mudaId"
                                    className={classNames({ 'p-error': isFormFieldValid('mudaId') })}
                                >
                                    Mudas
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            id="mudaId"
                                            name="mudaId"
                                            options={listMudas}
                                            filter={true}
                                            emptyMessage={"Nenhuma muda encontrada"}
                                            optionLabel="nome"
                                            optionValue="id"
                                            placeholder="Selecione uma muda"
                                            className={classNames({ 'p-invalid': isFormFieldValid('mudaId') })}
                                            value={formik.values.mudaId}
                                            onChange={option => formik.setFieldValue("mudaId", option.value)}
                                            emptyFilterMessage={"Nenhuma muda encontrada"}
                                            disabled={listMudas === ''}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.mudaId && formik.touched.mudaId &&
                                    <ErrorValidationMessage message={formik.errors.mudaId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-2">
                                <label
                                    htmlFor="quantidade"
                                    className={classNames({ 'p-error': isFormFieldValid('quantidade') })}
                                >
                                    Quantidade
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="quantidade"
                                            name="quantidade"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('quantidade') })}
                                            value={formik.values.quantidade}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.quantidade && formik.touched.quantidade &&
                                    <ErrorValidationMessage message={formik.errors.quantidade} />
                                }
                            </div>


                            <div className="p-d-flex p-jc-end p-mr-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    onClick={formik.handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-d-flex p-jc-end p-mr-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    tooltip='Adicionar todas as mudas'
                                    className="p-button-success"
                                    onClick={handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-formgrid p-grid p-fluid p-mx-0">

                            </div>


                        </div>

                    </form>
                </div>
            </div>


        </Fieldset>

    );
}
